import { DisconnectionFormValues } from "../types/DisconnectionFormValues";
import { EMPTY_METER_VALUES } from "./DisconnectionMeterValues";
import {
  ASSIGNED_ROLES,
  EMPTY_CONTACT_DETAILS,
} from "./EmptyContactDetailsValues";
import lodash from "lodash";

export const EMPTY_DISCONNECTION_ORDER: DisconnectionFormValues = {
  isUserLoggedIn: false,
  propertyDetails: {
    icpAddressLookupEnabled: true,
    icpAddressLookup: {
      id: "",
      label: "",
    },
    meterInfo: {
      meterCount: 1,
      meters: [EMPTY_METER_VALUES],
      addressInformation: {
        streetAddress: "",
        streetAddressId: "",
        manuallyEnteredAddress: false,
        manualStreetAddress: {
          streetNumber: "",
          streetName: "",
          suburb: "",
          unit: "",
          postcode: "",
        },
        additionalAddressInformation: "",
      },
    },
    type: "",
    guardDogs: false,
    lockedGate: false,
  },
  disconnectionDetails: {
    removalReason: "",
    hasTenants: "",
    hazards: "",
    otherInformation: "",
    filesUploadStatus: "",
    meterPhotos: [],
  },
  contactDetails: [
    {
      ...lodash.cloneDeep(EMPTY_CONTACT_DETAILS),
      role: "Requester",
      sameAsRole: "Requester",
      roles: { ...ASSIGNED_ROLES, requester: true },
      workContactPreferences: { email: true, sms: false },
    },
    {
      ...lodash.cloneDeep(EMPTY_CONTACT_DETAILS),
      role: "Quote payer",
    },
    {
      ...lodash.cloneDeep(EMPTY_CONTACT_DETAILS),
      role: "Property owner",
    },
    {
      ...lodash.cloneDeep(EMPTY_CONTACT_DETAILS),
      role: "Site contact",
    },
  ],
  declarations: [],
};
